namespace $ {

	class $shm_hitalama_map_widget_entity_table2_record_atom_link extends $giper_baza_atom_link.to(
		()=> $shm_hitalama_map_widget_entity_table2_record,
	) {}

	class $shm_hitalama_map_widget_entity_table2_record_list_link extends $giper_baza_list_link.to(
		()=> $shm_hitalama_map_widget_entity_table2_record,
	) {}

	export class $shm_hitalama_map_widget_entity_table2_record extends $giper_baza_entity.with({
		Dataset: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_dataset ),
		Initial: $giper_baza_atom_dict,
		Override_keys: $giper_baza_list_str,
		Meta: $giper_baza_atom_dict,
		Deleted: $giper_baza_atom_bool,
		Created_at: $giper_baza_atom_real,
		Updated_at: $giper_baza_atom_real,
		Created_by: $giper_baza_atom_text,
		Updated_by: $giper_baza_atom_text,
		Relation_roots: $giper_baza_dict_to( $giper_baza_atom_link ),
	}) {

		map() {
			return this.dataset()?.map() ?? null
		}

		dataset() {
			const owner = this.Dataset()?.remote()
			if( owner ) return owner
			const initial_owner = this.Initial()?.val()?.['__dataset']
			if( typeof initial_owner === 'string' && initial_owner ) return this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( initial_owner ),
				this.$.$shm_hitalama_map_widget_entity_table2_dataset,
			)
			const dataset = this.land().Data( $shm_hitalama_map_widget_entity_table2_dataset )
			if( dataset.records_all().some( record => record.link().str === this.link().str ) ) return dataset
			const link = this.link().str
			return this.land().Data( $shm_hitalama_map ).Datasets()?.remote_list().find( candidate =>
				candidate.records_all().some( record => record.link().str === link )
			) ?? null
		}

		history_events() {
			return this.map()?.history_maybe()?.events_for( this ) ?? []
		}

		history_scope_targets(
			changed?: $shm_hitalama_map_widget_entity_table2_field,
			before?: any,
			after?: any,
		) {
			const targets = new Set< string >([
				$shm_hitalama_map_history.scope_target( this ),
			])
			for( const field of this.dataset()?.fields() ?? [] ) {
				if( field.type() !== 'atom_link' ) continue
				const values = field.link().str === changed?.link().str
					? [ before, after ]
					: [ this.value( field ) ]
				for( const value of values ) for( const link of this.relation_links( value ) ) {
					targets.add( $shm_hitalama_map_history.scope_target( link ) )
				}
			}
			return [ ... targets ]
		}

		override units_of = ( peer: $giper_baza_link | null ) => {
			return this.$.$mol_error_fence(
				() => super.units_of( peer ),
				error => {
					if( peer?.str || !( error instanceof RangeError ) || error.message !== 'Invalid array length' ) return error
					const land = this.land()
					const latest = new Map< string, $giper_baza_unit_sand >()
					for( const unit of land.sand_ordered({ head: this.head(), peer: null }) ) {
						const self = unit.self().str
						const previous = latest.get( self )
						if( !previous || $giper_baza_unit_sand.compare( previous, unit ) > 0 ) latest.set( self, unit )
					}
					const units = [ ... latest.values() ].filter( unit => !unit.dead() && unit.self().str !== '' )
					land.sands_open( units )
					return units
				},
			)
		}

		system_values() {
			const initial = this.Initial()?.val()
			const meta = this.Meta()?.val()
			if( initial ) return {
				'Дата создания': meta?.created_at ?? initial['__created_at'] ?? '',
				'Дата обновления': meta?.updated_at ?? initial['__updated_at'] ?? '',
				'Создал': meta?.created_by ?? initial['__created_by'] ?? '',
				'Изменил': meta?.updated_by ?? initial['__updated_by'] ?? '',
			}
			return {
				'Дата создания': this.Created_at()?.val() ?? '',
				'Дата обновления': this.Updated_at()?.val() ?? '',
				'Создал': this.Created_by()?.val() ?? '',
				'Изменил': this.Updated_by()?.val() ?? '',
			}
		}

		@ $mol_action
		metadata_touch(
			stamp = Date.now(),
			user = this.$.$shm_hitalama_profile.current()?.link().str ?? '',
		) {
			const initial = this.Initial()?.val()
			if( initial ) {
				const meta = { ... this.Meta()?.val() }
				if( !( meta.created_at ?? initial['__created_at'] ) ) {
					meta.created_at = stamp
					if( user ) meta.created_by = user
				}
				meta.updated_at = stamp
				if( user ) meta.updated_by = user
				this.Meta( null )!.val( meta )
				return
			}
			if( !this.Created_at()?.val() ) {
				this.Created_at( null )!.val( stamp )
				if( user ) this.Created_by( null )!.val( user )
			}
			this.Updated_at( null )!.val( stamp )
			if( user ) this.Updated_by( null )!.val( user )
		}

		deleted( next?: boolean ) {
			return this.Deleted( next )?.val( next ) ?? false
		}

		field_pawn( field: $shm_hitalama_map_widget_entity_table2_field, auto?: null ) {
			const key = `Field:${ this.field_key( field ) }`
			switch( field.type() ) {
				case 'number': return this.dive( key, $giper_baza_atom_real, auto )
				case 'json': return this.dive( key, $giper_baza_atom_dict, auto )
				case 'file': return this.dive( key, $giper_baza_atom_link.to( ()=> $shm_hitalama_file ), auto )
				case 'atom_link': return this.dive( key, $shm_hitalama_map_widget_entity_table2_record_atom_link, auto )
				case 'list_link': return this.dive( key, $shm_hitalama_map_widget_entity_table2_record_list_link, auto )
				default: return this.dive( key, $giper_baza_atom_text, auto )
			}
		}

		field_key( field: $shm_hitalama_map_widget_entity_table2_field ) {
			return field.head().str
		}

		field_override( field: $shm_hitalama_map_widget_entity_table2_field, auto?: null ) {
			return this.dive( `FieldOverride:${ this.field_key( field ) }`, $giper_baza_atom_dict, auto )
		}

		value_prepare( field: $shm_hitalama_map_widget_entity_table2_field, next: any ) {
			if( next === '' || next === null || next === undefined ) {
				if( field.type() === 'list_link' ) return []
				if( field.type() === 'json' ) return {}
				return ''
			}

			switch( field.type() ) {
				case 'number': {
					const number = Number( next )
					if( !Number.isFinite( number ) ) throw new Error( 'Число должно быть конечным' )
					return number
				}
				case 'json': {
					const value = typeof next === 'string' ? JSON.parse( next ) : next
					if( !value || Array.isArray( value ) || typeof value !== 'object' ) throw new Error( 'JSON должен быть объектом' )
					return value
				}
				case 'list_link':
					return ( Array.isArray( next ) ? next : [ next ] ).map( String )
				case 'file':
				case 'atom_link':
					return String( next )
				default:
					return String( next )
			}
		}

		initial_write(
			fields: readonly $shm_hitalama_map_widget_entity_table2_field[],
			object: Record< string, any >,
			meta?: {
				dataset?: $shm_hitalama_map_widget_entity_table2_dataset
				stamp?: number
				user?: string
			},
		) {
			// Keep the immutable packing marker in the initial atom itself, rather
			// than posting an extra list item for every newly created record.
			const values: Record< string, any > = { '__packed': true }
			const large_relations: Array<{ field: $shm_hitalama_map_widget_entity_table2_field, links: string[] }> = []
			if( meta?.dataset ) values['__dataset'] = meta.dataset.link().str
			if( meta?.stamp ) {
				values['__created_at'] = meta.stamp
				values['__updated_at'] = meta.stamp
			}
			if( meta?.user ) {
				values['__created_by'] = meta.user
				values['__updated_by'] = meta.user
			}
			for( const field of fields ) {
				if( !Object.prototype.hasOwnProperty.call( object, field.title() ) ) continue
				const value = object[ field.title() ]
				if( value === '' || value === null || value === undefined ) continue
				const prepared = this.value_prepare( field, value )
				if(
					field.type() === 'list_link'
					&& Array.isArray( prepared )
					&& prepared.length > $shm_hitalama_map_widget_entity_table2_dataset.relation_page_size
					&& meta?.dataset
				) large_relations.push({ field, links: prepared })
				else values[ this.field_key( field ) ] = prepared
			}
			// A set of valid cells can exceed the size of a single Sand. Keep
			// metadata packed, but spill the cells through the existing overrides.
			// Measure the actual Baza encoding (not UTF-8/JSON character length).
			const spill = $giper_baza_vary.pack([ values ]).byteLength > 48000
			const stored = spill ? Object.fromEntries(
				Object.entries( values ).filter( ([ key ])=> key.startsWith( '__' ) ),
			) : values
			this.Initial( null )!.val( stored )
			// Concurrent first edits need the same already published list root.
			// Only its root is created here; changed-field entries remain lazy.
			this.Override_keys( null )
			if( spill ) $mol_wire_sync( this ).initial_spill( fields, object, meta?.dataset )
			for( const relation of large_relations ) meta!.dataset!.relation_replace( this, relation.field, relation.links )
			return values
		}

		@ $mol_action
		initial_spill(
			fields: readonly $shm_hitalama_map_widget_entity_table2_field[],
			object: Record< string, any >,
			dataset?: $shm_hitalama_map_widget_entity_table2_dataset,
		) {
			for( const field of fields ) {
				if( !Object.prototype.hasOwnProperty.call( object, field.title() ) ) continue
				const value = object[ field.title() ]
				if( value === '' || value === null || value === undefined ) continue
				// Large relations are initialized by their paged writer below.
				if( dataset && field.type() === 'list_link' && Array.isArray( value )
					&& value.length > $shm_hitalama_map_widget_entity_table2_dataset.relation_page_size ) continue
				this.override_mark( field )
				$mol_wire_sync( this ).value_write_raw( field, value, true )
			}
		}

		value( field: $shm_hitalama_map_widget_entity_table2_field, next?: any ): any {
			if( next !== undefined ) return this.value_write( field, next )
			if( field.type() === 'list_link' ) {
				// The field already identifies its dataset, including while the
				// record owner is still loading. Do not scan legacy record lands.
				const dataset = field.dataset() ?? this.dataset()
				if( dataset?.relation_has_pages( this, field ) ) return dataset.relation_values( this, field )
			}
			const initial = this.Initial()?.val()
			const override_keys = this.Override_keys()
			const key = this.field_key( field )
			if( initial && ( initial['__packed'] === true || override_keys?.has( '__packed' ) ) && !override_keys?.items().includes( key ) ) {
				return Object.prototype.hasOwnProperty.call( initial, key ) ? initial[ key ] : ''
			}
			const override = this.field_override( field )?.val()
			if( override && Object.prototype.hasOwnProperty.call( override, 'value' ) ) return override.value
			const pawn = this.field_pawn( field )
			if( !pawn ) {
				return initial && Object.prototype.hasOwnProperty.call( initial, key ) ? initial[ key ] : ''
			}
			if( field.type() === 'file' || field.type() === 'atom_link' ) {
				return ( pawn as $giper_baza_atom_link ).val()?.toString() ?? ''
			}
			if( field.type() === 'list_link' ) {
				return ( pawn as $giper_baza_list_link ).items().map( link => link.toString() )
			}
			if( field.type() === 'json' ) return ( pawn as $giper_baza_atom_dict ).val() ?? {}
			return ( pawn as $giper_baza_atom ).vary() ?? ''
		}

		values_for_query( fields: readonly $shm_hitalama_map_widget_entity_table2_field[] ) {
			const initial = this.Initial()?.val()
			const override_keys = this.Override_keys()
			if( !initial || !( initial['__packed'] === true || override_keys?.has( '__packed' ) ) ) return fields.map( field => this.value( field ) )
			const overrides = new Set( override_keys?.items() ?? [] )
			return fields.map( field => {
				const key = this.field_key( field )
				if( !overrides.has( key ) && field.type() !== 'list_link' ) {
					return Object.prototype.hasOwnProperty.call( initial, key ) ? initial[ key ] : ''
				}
				return this.value( field )
			} )
		}

		override_mark( field: $shm_hitalama_map_widget_entity_table2_field ) {
			const keys = this.Override_keys( null )!
			const key = this.field_key( field )
			if( !keys.items().includes( key ) ) keys.add( key )
		}

		@ $mol_action
		value_write(
			field: $shm_hitalama_map_widget_entity_table2_field,
			next: any,
			initial = false,
			automatic = false,
		): any {
			return $shm_hitalama_map_history.transaction( this.map(), 'Изменение ячейки', ()=> {
				// Once the raw write has happened, suspension must not change "before"
				// to our own new value and skip the remaining history/inverse/metadata.
				const plan = $mol_wire_sync( this ).value_write_plan( field, next, initial )
				const { previous, linked, before } = plan
				if( !initial && JSON.stringify( previous ) === JSON.stringify( plan.next ) ) return previous
				// A paged inverse list is derived without its own cell_set payload.
				// Index the direct command for the records whose backlinks it changes.
				const inverse_targets = linked && field.inverse_field()
					? [ ... before, ... this.relation_links( plan.next ) ] : []
				const result = this.value_write_raw( field, plan.next, initial )
				const dataset = this.dataset()
				if( !initial && dataset && this.map() ) {
					$shm_hitalama_map_history.capture( this.map(), {
						type: 'cell_set',
						target: this.link().str,
						targets: [
							field.link().str,
							dataset.link().str,
							... inverse_targets,
							... this.history_scope_targets( field, previous, result ),
						],
						before: previous,
						after: result,
						automatic,
						meta: {
							field: field.link().str,
							field_title: field.title(),
							dataset: dataset.link().str,
						},
					}, 'Изменение ячейки' )
				}
				// Drafts are real pawns but are not table records yet. Synchronizing their
				// inverse fields leaks draft links into persisted relations before submit.
				if( linked && dataset ) this.inverse_sync( field, before, this.relation_links( plan.next ) )
				$mol_wire_sync( this ).metadata_touch( plan.stamp, plan.user )
				return result
			} )
		}

		value_write_plan( field: $shm_hitalama_map_widget_entity_table2_field, next: any, initial: boolean ) {
			const type = field.type()
			if( type === 'list_link' && ( next === '' || next === null ) ) next = []
			const linked = type === 'atom_link' || type === 'list_link'
			const previous = !initial && ( this.Initial() || this.has( `Field:${ this.field_key( field ) }` ) )
				? this.value( field )
				: linked && type === 'list_link' ? [] : ''
			return { next, previous, linked, before: linked ? this.relation_links( previous ) : [],
				stamp: Date.now(), user: this.$.$shm_hitalama_profile.current()?.link().str ?? '' }
		}

		relation_links( value: any ) {
			const values = Array.isArray( value ) ? value : value ? [ value ] : []
			return [ ... new Set( values.map( item => new $giper_baza_link( String( item ) ).str ) ) ]
		}

		inverse_sync( field: $shm_hitalama_map_widget_entity_table2_field, before: readonly string[], after: readonly string[] ) {
			const inverse = field.inverse_field()
			const target = field.target_dataset()
			if( !inverse || !target || inverse.inverse_field()?.link().str !== field.link().str ) return
			if( !target.fields().some( item => item.link().str === inverse.link().str ) ) return

			const source = this.link().str
			for( const link of new Set([ ... before, ... after ]) ) {
				const was = before.includes( link )
				const is = after.includes( link )
				if( was === is ) continue
				const record = target.record_by_link( link )
				if( !record ) continue
				if( inverse.type() === 'list_link' ) {
					const owner = record.dataset()
					if( !owner ) continue
					if( !owner.relation_has_pages( record, inverse ) ) {
						const legacy = record.relation_links( record.value( inverse ) )
						owner.relation_replace( record, inverse, legacy )
					}
					if( is ) owner.relation_append( record, inverse, [ source ] )
					else owner.relation_remove( record, inverse, [ source ] )
					record.metadata_touch()
				} else if( inverse.type() === 'atom_link' ) {
					if( is ) record.value_write( inverse, source, false, true )
					else if( record.value( inverse ) === source ) record.value_write( inverse, '', false, true )
				}
			}
		}

		value_write_raw( field: $shm_hitalama_map_widget_entity_table2_field, next: any, initial = false ): any {
			if( field.type() === 'list_link' && !initial && ( this.Initial() || this.Dataset()?.remote() ) ) {
				const dataset = this.dataset()
				if( dataset ) {
					this.override_mark( field )
					return dataset.relation_replace( this, field, this.value_prepare( field, next ) )
				}
			}
			if( this.Initial() ) {
				const value = this.value_prepare( field, next )
				this.override_mark( field )
				if( field.type() === 'list_link' ) {
					;( this.field_pawn( field, null ) as $giper_baza_list_link ).items(
						( value as string[] ).map( link => new $giper_baza_link( link ) ),
					)
					return value
				}
				this.field_override( field, null )!.val({ value })
				return value
			}
			const key = `Field:${ this.field_key( field ) }`
			if( next === '' || next === null ) {
				if( field.type() === 'list_link' ) next = []
				else if( field.type() === 'json' ) next = {}
				else if( field.type() !== 'number' && field.type() !== 'file' && field.type() !== 'atom_link' ) {
					const pawn = this.field_pawn( field, null ) as $giper_baza_atom_text | null
					pawn?.val( '' )
					return ''
				} else {
					if( !initial && this.has( key ) ) this.has( key, false )
					return ''
				}
			}
			const tag = field.type() === 'list_link' ? 'vals' : 'solo'
			const existing = this.find( key )
			if( !initial && existing && existing.tag() !== tag ) this.has( key, false )
			const pawn = this.field_pawn( field, null )
			if( !pawn ) return ''

			if( field.type() === 'list_link' ) {
				const links = Array.isArray( next ) ? next : next ? [ next ] : []
				;( pawn as $giper_baza_list_link ).items( links.map( link =>
					link instanceof $giper_baza_link ? link : new $giper_baza_link( String( link ) )
				) )
				return links.map( String )
			}

			switch( field.type() ) {
				case 'number':
					const number = Number( next )
					if( !Number.isFinite( number ) ) throw new Error( 'Число должно быть конечным' )
					;( pawn as $giper_baza_atom_real ).val( number )
					return number
				case 'json': {
					const value = typeof next === 'string' ? JSON.parse( next ) : next
					if( !value || Array.isArray( value ) || typeof value !== 'object' ) throw new Error( 'JSON должен быть объектом' )
					;( pawn as $giper_baza_atom_dict ).val( value )
					return value
				}
				case 'file':
				case 'atom_link':
					;( pawn as $giper_baza_atom_link ).val( next instanceof $giper_baza_link ? next : new $giper_baza_link( String( next ) ) )
					return String( next )
				default:
					;( pawn as $giper_baza_atom_text ).val( String( next ) )
					return String( next )
			}
		}

		object( fields: readonly $shm_hitalama_map_widget_entity_table2_field[] ) {
			return Object.fromEntries( fields.map( field => [ field.title(), this.value( field ) ] ) )
		}

		object_write(
			fields: readonly $shm_hitalama_map_widget_entity_table2_field[],
			object: Record< string, any >,
			skip_empty = false,
		) {
			for( const field of fields ) {
				if( !Object.prototype.hasOwnProperty.call( object, field.title() ) ) continue
				if( skip_empty && ( object[ field.title() ] === '' || object[ field.title() ] === null ) ) continue
				this.value_write( field, object[ field.title() ], skip_empty )
			}
			return this.object( fields )
		}

	}

}
